import { Provider } from "@angular/core";
import { IKeyValueStore, MOBILE_KEY_VALUE_STORE } from "./key-value-store.interface";
import { LocalStorageStore } from "./local-storage.store";
import { SqliteStore } from "./sqlite.store";

export function provideMobileCacheStore(): Provider[] {
  return [
    LocalStorageStore,
    SqliteStore,
    {
      provide: MOBILE_KEY_VALUE_STORE,
      useFactory: (localStore: LocalStorageStore, sqliteStore: SqliteStore): IKeyValueStore => {
        const isNativeRuntime =
          typeof window !== "undefined" &&
          !!(window as Window & { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor
            ?.isNativePlatform?.();
        return isNativeRuntime ? sqliteStore : localStore;
      },
      deps: [LocalStorageStore, SqliteStore],
    },
  ];
}
